import type {GridApi} from 'ag-grid-community';

/**
 * Whether the rows drawn reach the last one the grid holds, which is what asks for the next
 * page. ag-grid renders a buffer past the viewport, so this turns true a few rows before the
 * bottom is actually on screen - early enough that the next page is there when it is reached.
 */
export function isLastRowRendered(api: Pick<GridApi, 'getLastDisplayedRowIndex' | 'getDisplayedRowCount'>): boolean {
    return api.getLastDisplayedRowIndex() >= api.getDisplayedRowCount() - 1;
}
